import {useFluxServices} from "injection/hooks";

export function useFluxClaims<T extends "superadmin" | "admin" | "internal">(claimName?: T) {
    const services = useFluxServices();
    const hook = services.useFluxClaimsStore;

    return hook((state) => {
        if (claimName) {
            return {
                claim: state.claims[claimName],
                isLoading: state.isLoading,
                error: state.error,
            };
        }
        return {
            claims: state.claims,
            isLoading: state.isLoading,
            error: state.error,
        };
    });
}
